import {
  EquipmentFilter,
  MuscleGroupFilter,
  MuscleGroup,
  Equipment,
  CustomExerciseType,
} from 'hevy-shared';
import { t } from 'translations/t';

export const customExerciseTypeToHuman = (type: CustomExerciseType): string => {
  const customExerciseTypeToHumanMap: { [key in CustomExerciseType]: string } = {
    weight_reps: t('web.exerciseType.weightReps'),
    bodyweight_reps: t('web.exerciseType.weightedBodyweight'),
    bodyweight_assisted_reps: t('web.exerciseType.assBodyweight'),
    reps_only: t('web.exerciseType.repsOnly'),
    duration: t('web.exerciseType.duration'),
    weight_duration: t('web.exerciseType.weightDuration'),
    distance_duration: t('web.exerciseType.distanceDuration'),
    short_distance_weight: t('web.exerciseType.weightDistance'),
  };

  return customExerciseTypeToHumanMap[type];
};

export const equipmentToHuman = (equipment: Equipment): string => {
  const equipmentToHumanMap: { [key in Equipment]: string } = {
    none: t('exerciseData.equipment.none'),
    machine: t('exerciseData.equipment.machine'),
    kettlebell: t('exerciseData.equipment.kettlebell'),
    barbell: t('exerciseData.equipment.barbell'),
    dumbbell: t('exerciseData.equipment.dumbbell'),
    plate: t('exerciseData.equipment.plate'),
    resistance_band: t('exerciseData.equipment.resistanceBand'),
    suspension: t('web.exerciseEquipment.suspension'),
    other: t('exerciseData.equipment.other'),
  };

  return equipmentToHumanMap[equipment];
};

export const equipmentFilterToHuman = (equipmentFilter: EquipmentFilter): string => {
  const equipmentFilterToHumanMap: { [key in EquipmentFilter]: string } = {
    all_equipment: t('web.exerciseEquipment.all'),
    none: t('exerciseData.equipment.none'),
    machine: t('exerciseData.equipment.machine'),
    kettlebell: t('exerciseData.equipment.kettlebell'),
    barbell: t('exerciseData.equipment.barbell'),
    dumbbell: t('exerciseData.equipment.dumbbell'),
    plate: t('exerciseData.equipment.plate'),
    resistance_band: t('exerciseData.equipment.resistanceBand'),
    suspension: t('web.exerciseEquipment.suspension'),
    other: t('exerciseData.equipment.other'),
  };

  return equipmentFilterToHumanMap[equipmentFilter];
};

export const muscleGroupToHuman = (muscleGroup: MuscleGroup): string => {
  const muscleGroupToHuman: { [key in MuscleGroup]: string } = {
    abdominals: t('exerciseData.muscleGroup.abdominals'),
    cardio: t('exerciseData.muscleGroup.cardio'),
    shoulders: t('exerciseData.muscleGroup.shoulders'),
    chest: t('exerciseData.muscleGroup.chest'),
    lower_back: t('exerciseData.muscleGroup.lowerBack'),
    full_body: t('exerciseData.muscleGroup.fullBody'),
    biceps: t('exerciseData.muscleGroup.biceps'),
    triceps: t('exerciseData.muscleGroup.triceps'),
    upper_back: t('exerciseData.muscleGroup.upperBack'),
    quadriceps: t('exerciseData.muscleGroup.quadriceps'),
    calves: t('exerciseData.muscleGroup.calves'),
    lats: t('exerciseData.muscleGroup.lats'),
    hamstrings: t('exerciseData.muscleGroup.hamstrings'),
    glutes: t('exerciseData.muscleGroup.glutes'),
    abductors: t('exerciseData.muscleGroup.abductors'),
    adductors: t('exerciseData.muscleGroup.adductors'),
    traps: t('exerciseData.muscleGroup.traps'),
    forearms: t('exerciseData.muscleGroup.forearms'),
    neck: t('exerciseData.muscleGroup.neck'),
    other: t('exerciseData.muscleGroup.other'),
  };

  return muscleGroupToHuman[muscleGroup];
};

export const muscleGroupFilterToHuman = (muscleGroupFilter: MuscleGroupFilter): string => {
  const muscleGroupFilterToHuman: { [key in MuscleGroupFilter]: string } = {
    all_muscles: t('web.muscleGroupFilter.all'),
    abdominals: t('exerciseData.muscleGroup.abdominals'),
    cardio: t('exerciseData.muscleGroup.cardio'),
    shoulders: t('exerciseData.muscleGroup.shoulders'),
    chest: t('exerciseData.muscleGroup.chest'),
    lower_back: t('exerciseData.muscleGroup.lowerBack'),
    full_body: t('exerciseData.muscleGroup.fullBody'),
    biceps: t('exerciseData.muscleGroup.biceps'),
    triceps: t('exerciseData.muscleGroup.triceps'),
    upper_back: t('exerciseData.muscleGroup.upperBack'),
    quadriceps: t('exerciseData.muscleGroup.quadriceps'),
    calves: t('exerciseData.muscleGroup.calves'),
    lats: t('exerciseData.muscleGroup.lats'),
    hamstrings: t('exerciseData.muscleGroup.hamstrings'),
    glutes: t('exerciseData.muscleGroup.glutes'),
    abductors: t('exerciseData.muscleGroup.abductors'),
    adductors: t('exerciseData.muscleGroup.adductors'),
    traps: t('exerciseData.muscleGroup.traps'),
    forearms: t('exerciseData.muscleGroup.forearms'),
    neck: t('exerciseData.muscleGroup.neck'),
    other: t('exerciseData.muscleGroup.other'),
  };

  return muscleGroupFilterToHuman[muscleGroupFilter];
};
